
import SideMenu from 'Src/js/components/SideMenu.vue';
import TireRecommender from 'JS/automotive/tire-recommendation/components/TireRecommender.vue';
import VehicleLookup from 'JS/components/automotive/vehicle-lookup/VehicleLookup.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { ICustomerVehicle } from 'JS/types/Automotive';

@Component({
	name: 'TireRecommendationSidebar',
	components: {
		SideMenu,
		TireRecommender,
		VehicleLookup
	}
})
export default class TireRecommendationSidebar extends Vue {

	/* Props
	============================================*/

	@Prop({ type: Boolean, required: false })
	readonly show: boolean;

	@Prop({ type: Object, required: false })
	readonly initialVehicle?: ICustomerVehicle;

	/* Data
	============================================*/

	currentStep: number = 1;
	answerIds: number[];
	vehicle: ICustomerVehicle | null = null;

	/* Methods
	============================================*/

	setVehicle(vehicle: ICustomerVehicle) {
		this.vehicle = vehicle;
		this.$emit('savedVehicle', vehicle);
	}

	/* Watchers
	============================================*/

	@Watch('show')
	showChanged(showNew: boolean) {
		if (!showNew) return;
		this.vehicle = this.initialVehicle || null;
	}

}

